'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setFieldGroupOrder = exports.fetchFieldGroupOrder = exports.deleteField = exports.updateField = exports.createField = exports.fetchField = exports.fetchFields = undefined;

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchFields = exports.fetchFields = function fetchFields(entity) {
  return (0, _callApi2.default)('GET', '/fields/' + entity.toLowerCase());
};
var fetchField = exports.fetchField = function fetchField(id) {
  return (0, _callApi2.default)('GET', '/field/' + id);
};
var createField = exports.createField = function createField(field) {
  return (0, _callApi2.default)('POST', '/field/' + field._id, field, 'application/json');
};
var updateField = exports.updateField = function updateField(field) {
  return (0, _callApi2.default)('PUT', '/field/' + field._id, field, 'application/json');
};
var deleteField = exports.deleteField = function deleteField(id) {
  return (0, _callApi2.default)('DELETE', '/field/' + id);
};
var fetchFieldGroupOrder = exports.fetchFieldGroupOrder = function fetchFieldGroupOrder(entity) {
  return (0, _callApi2.default)('GET', '/fields/' + entity + '/group-order', null, 'application/json');
};
var setFieldGroupOrder = exports.setFieldGroupOrder = function setFieldGroupOrder(entity, group_list) {
  return (0, _callApi2.default)('POST', '/fields/' + entity + '/group-order', { group_list: group_list, entity: entity }, 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/fields.js
// module id = 731
// module chunks = 0